import React from 'react'
import Navbar from '../components/Navbar'
import ProductCard from '../components/ProductCard'
import Footer from '../components/Footer'
function HomePage() {
  return (
    <div>
      <Navbar/>
      <ProductCard/>
      <Footer/>
    </div>
  )
}

export default HomePage
